var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.959,
    height: 14.07,
    viewBox: "0 0 11.959 14.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Duplicate",
    transform: "translate(-88.295 -369.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "content_copy_FILL1_wght400_GRAD0_opsz48",
    d: "M7.055,18.02A1.082,1.082,0,0,1,6,16.964V6.359H7.055v10.6h8.336V18.02Zm2.11-2.11A1.082,1.082,0,0,1,8.11,14.854V5.005A1.082,1.082,0,0,1,9.166,3.95H16.9a1.082,1.082,0,0,1,1.055,1.055v9.849A1.082,1.082,0,0,1,16.9,15.909Z",
    transform: "translate(82.295 365.98)",
    fill: "#9eabb0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.c236a750e3dc08da495a3a7b20891536.svg";
export { ForwardRef as ReactComponent };